export default "__VITE_ASSET__TlcrSDME__"